export const environment = {
  production: true,
  _privateKey: 'BOXOFTECH@2022@415',
  // apiGatewayUrl: 'http://122.165.224.116:8087',
  ShowLicenseInfo: true,
  AppTitle: 'Commander',
  AppLogo: '/assets/logo/app-logo-white.png',
  AppLogoSmall: '/assets/logo/app-logo-small-white.png'
};
